import type { Style } from 'mapbox-gl'
import { MAPTILER_STYLES } from '../config'
import { MAPBOX_TOKEN } from '../config'

export type MapStyle = string | Style
export type SatelliteStyle = MapStyle | ((lang: string) => MapStyle)

export enum PROGRESS_TYPES {
  IDLE = 'idle',
  WORK = 'work',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum LOGIN_ERROR_TYPES {
  NONE,
  INVALID_EMAIL_OR_PASSWORD,
  ERROR,
}

export enum PATH {
  SIGNIN = '/signin',
  MAIN = '/',
  MAIN_PROJECT = '/:projectId',
  VIDEO = '/:projectId/video/:id',
  ROUTE_MARKING = '/route-marking',
  PRINT_REPORT = '/report',
  RESTORE_PASSWORD = '/restore-password',
  NEW_PASSWORD = '/new-password',
  EMPTY = '',
  OTHERS = '*',
  NOT_FOUND = '/404',
}

export const MAPBOX_ACCESS_TOKEN = MAPBOX_TOKEN

export const STYLES: { VECTOR: MapStyle; SATELLITE: SatelliteStyle } = {
  VECTOR: MAPTILER_STYLES.VECTOR as MapStyle,
  SATELLITE: MAPTILER_STYLES.SATELLITE as unknown as SatelliteStyle,
}
